import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  LinearProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { UploadFileOutlined } from "@mui/icons-material";

const UploadProfileAndCoverImage = ({
  open,
  onClose,
  setFilePathName,
  getAlumniDetails,
  setPresignedImage,
}) => {
  const [isCapture, setIsCapture] = useState(false);
  const [isUploadfromDevice, setIsUploadfromDevice] = useState(false);
  const [picture, setPicture] = useState(null);
  const [pictureType, setPictureType] = useState(""); // Track which picture type to upload
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const CHUNK_SIZE = 1 * 900 * 900; // 1MB

  const RequestId = useRequestIdGenerater();
  const { generateTimeStamp, rendomRequestId } = useTimeStamp();

  const uploadChunk = async (file, chunk, chunkIndex, totalChunks) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", chunk);
    formData.append("chunkIndex", chunkIndex);
    formData.append("totalChunks", totalChunks);
    formData.append("fileName", file.name);
    const response = await axios.post(
      "/v1/upload",
      formData,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "multipart/form-data",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      }
    );

    if (response?.data !== null) {
      if (chunkIndex === totalChunks - 1) {
        setUploading(false);
        setUploadComplete(true);
        setPresignedImage(response?.data?.data?.preSignedUrl);
        setFilePathName(response?.data?.data?.filePath);
      }
    }
  };

  const uploadFile = async (file) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    for (let i = 0; i < totalChunks; i++) {
      const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      await uploadChunk(file, chunk, i, totalChunks);
      setUploadProgress(((i + 1) / totalChunks) * 100);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
      setPicture(file);
    } else {
      alert("Please upload a valid image file (JPEG or PNG).");
    }
  };

  useEffect(() => {
    generateTimeStamp();
  }, []);

  useEffect(() => {
    if (uploadComplete) {
      onClose();
      setIsCapture(false);
      // setIsUploadfromDevice(false);
    }
  }, [uploadComplete]);

  return (
    <Dialog
      open={open}
      // onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Profile Picture</DialogTitle>

      <DialogContent sx={{ width: 440 }}>
        <Typography sx={{ padding: 2, fontSize: 17, fontWeight: 400 }}>
          A picture helps people recognize your Group 📷
        </Typography>

        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid item>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: 16,
              }}
              onClick={() => {
                setIsUploadfromDevice(true);
                setPictureType("profile");
              }}
            >
              <UploadFileOutlined sx={{ marginRight: 1 }} /> Upload Profile
              Picture
            </Typography>
            <TextField
              inputProps={{ accept: "image/jpeg,image/png" }}
              onChange={handleFileChange}
              type="file"
              InputProps={{
                style: { height: "50px", marginTop: "5px" },
              }}
            />
          </Grid>
        </Grid>
        {uploading && (
          <Grid item md={12} xs={12} mt={1}>
            <LinearProgress variant="determinate" value={uploadProgress} />
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={uploading}
          onClick={() => uploadFile(picture)}
          autoFocus
        >
          {uploading ? "Uploading" : "Upload"}
        </Button>
        <Button
          disabled={uploading}
          onClick={() => {
            onClose();
            setIsCapture(false);
            setIsUploadfromDevice(false);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadProfileAndCoverImage;
